import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsync, useAsyncFn } from 'react-use';
import { useConfig } from '@app/config';

export function usePendingRewardsDetails() {
  const config = useConfig();
  const { contract } = useContract(config?.CONTRACTS.DIVIDENDS);
  const address = useAddress();

  const { value, loading: loadingTokenBalance } = useAsync(async () => {
    if (!contract) {
      return;
    }

    const distributedTokensLength = await contract.call(
      'distributedTokensLength'
    );

    const distributedTokensIndexes = new Array(+distributedTokensLength)
      .fill(0)
      .map((_, index) => index);

    const pendingAmounts = await Promise.all(
      distributedTokensIndexes.map(async index => {
        try {
          const distributedToken = await contract.call('distributedToken', [
            index
          ]);

          const pendingDividendsAmount = await contract.call(
            'pendingDividendsAmount',
            [distributedToken, address]
          );

          return {
            distributedToken,
            pendingDividendsAmount
          };
        } catch (e) {
          // console.log(e);
        }
      })
    );

    return {
      distributedTokensIndexes,
      pendingAmounts,
      hasItemsToClaim: pendingAmounts.some(
        item => item?.pendingDividendsAmount.toString() > 0
      )
    };
  }, [contract, address]);

  const [{ loading: claiming }, claimAll] = useAsyncFn(async () => {
    if (!contract) {
      return;
    }

    return contract?.call('harvestAllDividends');
  }, [contract]);

  return {
    distributedTokensIndexes: value?.distributedTokensIndexes ?? [],
    claimAll,
    claiming,
    pendingAmounts: value?.pendingAmounts ?? [],
    hasItemsToClaim: !!value?.hasItemsToClaim
  };
}
